import React from "react";

const Home = ({ campaigns,creators, brands }) => {
  //const cards = Array.from({ length:6 });

  return (
    <div className="flex flex-wrap gap-4 mt-6">
      <div className="p-4 bg-white border rounded-lg shadow hover:shadow-lg transition duration-300">
        <h3 className="text-lg font-semibold mb-2">Total Campaigns</h3>
        <p className="text-2xl font-bold mb-0">{campaigns.length}</p>
      </div>

      <div className="p-4 bg-white border rounded-lg shadow hover:shadow-lg transition duration-300">
        <h3 className="text-lg font-semibold mb-2">Total Creators</h3>
        <p className="text-2xl font-bold mb-0">{creators.length}</p>
      </div>

      <div className="p-4 bg-white border rounded-lg shadow hover:shadow-lg transition duration-300">
        <h3 className="text-lg font-semibold mb-2">Total Brands</h3>
        <p className="text-2xl font-bold mb-0">{brands?.length}</p>
      </div>

    </div>
  );
};

/* Add this inside the return statement after <div>Home</div> */

export default Home;
